import { isBillingEnabledFor } from '@/config';
import PrivateRoute from '@/modules/auth/components/PrivateRoute';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import BillingDetailsEdit from '@/modules/billing/pages/BillingDetailsEdit';
import BillingHome from '@/modules/billing/pages/BillingHome';
import InvoiceDetails from '@/modules/billing/pages/InvoiceDetails';
import InvoiceList from '@/modules/billing/pages/InvoiceList';
import PaymentMethodSetup from '@/modules/billing/pages/PaymentMethodAdd';
import PaymentMethodList from '@/modules/billing/pages/PaymentMethodList';
import UpgradePlan from '@/modules/billing/pages/UpgradePlan';
import UpgradePlanPaymentSetup from '@/modules/billing/pages/UpgradePlanPaymentSetup';
import {
  BillingDetailsEditPath,
  BillingHomePath,
  BillingInvoiceDetailsPath,
  BillingInvoiceListPath,
  BillingPaymentMethodAddPath,
  BillingPaymentMethodListPath,
  BillingUpgradePlanPath,
  BillingUpgradePlanPaymentSetupPath,
} from '@/modules/billing/paths';
import { UserRole } from '@/modules/retailer/models/User';
import Home from '@/modules/retailer/pages/Home';
import Orders from '@/modules/retailer/pages/Orders';
import Settings from '@/modules/retailer/pages/Settings/Settings';
import Stores from '@/modules/retailer/pages/Stores';
import {
  RetailerHomePath,
  RetailerOrdersPath,
  RetailerSettingsPath,
  RetailerStoresPath,
} from '@/modules/retailer/paths';
import Currency from '@/modules/settings/pages/Currency';
import Language from '@/modules/settings/pages/Language';
import Notification from '@/modules/settings/pages/Notification';
import Password from '@/modules/settings/pages/Password';
import Profile from '@/modules/store/pages/Settings/Profile';
import { HomePath } from '@/routing/paths';
import { Navigate, Routes as ReactRoutes, Route } from 'react-router-dom';

const Routes = () => {
  const { role } = useAuth();
  const isRetailerBillingEnabled = isBillingEnabledFor('retailer');

  return (
    <ReactRoutes>
      <Route element={<PrivateRoute />}>
        {role === UserRole.RetailerAdmin ? (
          <>
            <Route path={RetailerHomePath} Component={Home} />
            <Route path={RetailerStoresPath} Component={Stores} />
            <Route path={RetailerOrdersPath} Component={Orders} />
            <Route Component={Settings}>
              <Route path={RetailerSettingsPath.profile} Component={Profile} />
              <Route path={RetailerSettingsPath.currency} Component={Currency} />
              <Route path={RetailerSettingsPath.language} Component={Language} />
              <Route path={RetailerSettingsPath.notification} Component={Notification} />
              <Route path={RetailerSettingsPath.password} Component={Password} />
              {isRetailerBillingEnabled && (
                <>
                  <Route path={BillingHomePath} Component={BillingHome} />
                  <Route path={BillingInvoiceListPath} Component={InvoiceList} />
                  <Route path={BillingInvoiceDetailsPath.path} Component={InvoiceDetails} />
                  <Route path={BillingDetailsEditPath} Component={BillingDetailsEdit} />
                  <Route path={BillingUpgradePlanPath} Component={UpgradePlan} />
                  <Route
                    path={BillingUpgradePlanPaymentSetupPath}
                    Component={UpgradePlanPaymentSetup}
                  />
                  <Route path={BillingPaymentMethodListPath} Component={PaymentMethodList} />
                  <Route path={BillingPaymentMethodAddPath} Component={PaymentMethodSetup} />
                </>
              )}
            </Route>
          </>
        ) : (
          <>
            <Route path={RetailerHomePath} element={<Navigate to={HomePath} replace />} />
            <Route path={RetailerStoresPath} element={<Navigate to={HomePath} replace />} />
            <Route path={RetailerOrdersPath} element={<Navigate to={HomePath} replace />} />
          </>
        )}
      </Route>
    </ReactRoutes>
  );
};

export default Routes;
